// The contact's return steps waiting on the OMS API (2026-10-29): read on
// open and whenever refreshKey changes; "Check now" re-reads. A failed read
// leaves nothing shown (never blocks the panel).

import { useCallback, useEffect, useState } from 'react'
import { fetchConversationReturnLabels, checkReturnLabelNow, fetchZeroDollarTiming } from './api.js'

export function useReturnLabels(conversationId, refreshKey = 0) {
  const [data, setData] = useState(null)
  const load = useCallback(() => {
    if (!conversationId) { setData(null); return Promise.resolve(null) }
    return fetchConversationReturnLabels(conversationId).then((d) => { setData(d); return d }).catch(() => { setData(null); return null })
  }, [conversationId])
  useEffect(() => { load() }, [load, refreshKey])
  const checkNow = useCallback(async (id) => {
    await checkReturnLabelNow(id)
    await load()
  }, [load])
  return { data, reload: load, checkNow }
}

// The $0 RMA typical wait, in words, once enough are measured (else null:
// the banner says "a few hours"). Read once per page.
let timingPromise = null
export function useZeroDollarTiming(enabled = true) {
  const [typical, setTypical] = useState(null)
  useEffect(() => {
    if (!enabled) return
    timingPromise = timingPromise ?? fetchZeroDollarTiming().catch(() => null)
    let live = true
    timingPromise.then((t) => { if (live) setTypical(t?.typical ?? null) })
    return () => { live = false }
  }, [enabled])
  return typical
}
